/**
 * The "Execution" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const EXECUTION_ITEMS = [
  {
    href: "/dem-cog/reports",
    label: "Deal Clinic",
    iconName: "IoBarChartOutline",
    requires: "dealClinic",
  },
  {
    // Opens on the rep's analyzed calls, uploaded or recorded, with "Analyze
    // a conversation" on the list, as Deal Clinic opens on its readouts with
    // "Diagnose Deal". The analyzer itself is a step, not a destination
    // (Michael, 20 October).
    href: "/dashboard/transcript-results",
    label: "Conversation Analysis",
    shortcut: "A",
    iconName: "IoStatsChartOutline",
    requires: "conversationAnalysis",
  },
  {
    // The live call coach: in a browser, the page that offers the desktop and
    // phone apps; inside the desktop app, Guide itself. Open to every member.
    href: "/guide",
    label: "Guide - Live Call Coach",
    iconName: "IoNavigateCircleOutline",
    requires: "workspace",
  },
  {
    href: "/simulator/on-the-fly",
    label: "On-the-fly Plays",
    iconName: "LiaTheaterMasksSolid",
    requires: "onTheFly",
  },
  {
    href: "/workspaces/scripts",
    label: "Email & Talking Script Generator",
    iconName: "IoDocumentTextOutline",
    requires: "scriptGenerator",
  },
  {
    // Prep5 is an external service. Practice-only studios should not see the
    // Execution menu at all (SAL-2532), so only offer Prep5 once the studio has
    // at least one execution module enabled. Training-mode restrictions also
    // apply, with the usual exemptions for admins, supervisors, and superusers.
    href: "https://prep5.salesably.ai/dashboard",
    label: "Prep5 - AI Sales Preparation",
    iconName: "IoFlashOutline",
    external: true,
    requires: ["anyExecutionModule", "notTrainingModeRestricted"],
  },
];
